<template>
    <div class="setting-component">
        <!-- [ Menu ] end -->
        <div class="wrap">
            <div class="wrap__tree">
                <!--{{activeTab}}-->
                <el-tabs v-model="activeTab" @tab-click="handleClickTabs">
                    <el-tab-pane name="projectTaxes" :label="$t('settings_accountThink_taxTypes_taxes')">
                        <div class="nav-tree">
                            <el-button @click="openModalAdd(activeTab)" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-plus">Add Sales Tax</el-button>
                        </div>
                        <el-table
                                max-height="600"
                                :data="tableData"
                                :empty-text="$t('general_noData')"
                                style="width: 100%">
                            <el-table-column
                              label="ID"
                              type="index"
                              width="50">
                            </el-table-column>
                            <el-table-column
                                    prop="code"
                                    sortable
                                    :label="$t('settings_accountThink_taxTypes_code')"
                                    width="150">
                            </el-table-column>
                            <el-table-column
                                    prop="name"
                                    :label="$t('settings_accountThink_taxTypes_name')"
                                    width="220">
                            </el-table-column>
                            <el-table-column
                                    prop="value"
                                    :label="$t('settings_accountThink_taxTypes_rate')"
                                    width="70">
                            </el-table-column>
                            <el-table-column
                                    prop="description"
                                    :label="$t('settings_accountThink_taxTypes_description')">
                            </el-table-column>
                            <el-table-column
                                    :label="$t('settings_accountThink_taxTypes_linkedAccount')"
                                    width="200">
                                    <template slot-scope="scope">
                                      {{scope.row.taxAccountName ? scope.row.taxAccountName.join(', ') : ''}}
                                    </template>
                            </el-table-column>
                            <el-table-column
                                    prop="createDate"
                                    :label="$t('settings_accountThink_taxTypes_createDate')"
                                    width="100">
                            </el-table-column>
                            <el-table-column
                                    width="120"
                                    :label="$t('settings_accountThink_taxTypes_operations')">
                                <template slot-scope="scope">
                                    <el-button
                                            size="mini"
                                            type="primary"
                                            plain
                                            icon="el-icon-edit"
                                            @click="handleEdit(scope.$index, scope.row)"></el-button>
                                    <el-button
                                            size="mini"
                                            type="danger"
                                            plain
                                            icon="el-icon-delete"
                                            @click="handleDelete(scope.$index, scope.row)"></el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane name="withholdingTaxes" :label="$t('settings_accountThink_taxTypes_withholdingTaxes')">
                        <div class="nav-tree">
                            <el-button @click="openModalAdd(activeTab)" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-plus">{{$t('general_add')}} {{btnText}}</el-button>
                        </div>
                        <el-table
                                max-height="600"
                                :data="tableData"
                                :empty-text="$t('general_noData')"
                                style="width: 100%">
                            <el-table-column
                              label="ID"
                              type="index"
                              width="50">
                            </el-table-column>
                            <el-table-column
                                    prop="code"
                                    sortable
                                    :label="$t('settings_accountThink_taxTypes_code')"
                                    width="150">
                            </el-table-column>
                            <el-table-column
                                    prop="name"
                                    :label="$t('settings_accountThink_taxTypes_name')"
                                    width="220">
                            </el-table-column>
                            <el-table-column
                                    prop="value"
                                    :label="$t('settings_accountThink_taxTypes_rate')"
                                    width="80">
                            </el-table-column>
                            <el-table-column
                                    prop="remark"
                                    :label="$t('settings_accountThink_taxTypes_remark')"
                                    width="150">
                            </el-table-column>
                            <el-table-column
                                    prop="description"
                                    :label="$t('settings_accountThink_taxTypes_description')">
                            </el-table-column>
                            <el-table-column
                                    :label="$t('settings_accountThink_taxTypes_linkedAccount')"
                                    width="200">
                                    <template slot-scope="scope">
                                      {{scope.row.taxAccountName ? scope.row.taxAccountName.join(', ') : ''}}
                                    </template>
                            </el-table-column>
                            <el-table-column
                                    prop="createDate"
                                    :label="$t('settings_accountThink_taxTypes_createDate')"
                                    width="100">
                            </el-table-column>
                            <el-table-column
                                    width="120"
                                    :label="$t('settings_accountThink_taxTypes_operations')">
                                <template slot-scope="scope">
                                    <el-button
                                            size="mini"
                                            type="primary"
                                            plain
                                            icon="el-icon-edit"
                                            @click="handleEdit(scope.$index, scope.row)"></el-button>
                                    <el-button
                                            size="mini"
                                            type="danger"
                                            plain
                                            icon="el-icon-delete"
                                            @click="handleDelete(scope.$index, scope.row)"></el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
        <!--TAXES CREATE MODAL START-->
        <sweet-modal blocking title="Add Sales Tax" ref="openModal" class="modal" v-on:close="closeModal">
            <el-form :model="form" ref="form" status-icon :rules="rules" label-width="0" class="demo-ruleForm">
                <!--<el-form-item prop="no">-->
                    <!--<el-input :placeholder="paleceholderText + ` #`" v-model="form.no"></el-input>-->
                <!--</el-form-item>-->
                <el-form-item prop="name">
                    <el-input :label="$t('settings_accountThink_taxTypes_name')" v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input :label="$t('settings_accountThink_taxTypes_code')" v-model="form.code"></el-input>
                </el-form-item>
                <el-form-item prop="value">
                    <el-input type="number" label="Rate" v-model="form.value"></el-input>
                </el-form-item>

                <!-- <el-form-item>
                  <el-radio v-model="form.typeVAT" :label="1">{{$t('settings_accountThink_taxTypes_outputVAT')}}</el-radio>
                  <el-radio v-model="form.typeVAT" :label="2">{{$t('settings_accountThink_taxTypes_inputVAT')}}</el-radio>
                </el-form-item> -->

                <el-form-item prop="description">
                    <el-input :placeholder="$t('settings_accountThink_taxTypes_description')" type="textarea" v-model="form.description"></el-input>
                </el-form-item>
                <el-form-item class="modal__btn">
                  <el-button @click="modalCancel('openModal')">{{$t('general_cancel')}}</el-button>
                  <el-button @click="addItem('form')" type="primary">{{$t('general_submit')}}</el-button>
                </el-form-item>
            </el-form>
        </sweet-modal>
        <!--TAXES CREATE MODAL END-->

        <!--TAXES EDIT MODAL START-->
        <sweet-modal blocking title="Edit Sales Tax" ref="openModalEdit" class="modal" v-on:close="closeModalEdit">
            <el-form :model="formEdit" ref="formEdit" status-icon :rules="rulesEdit" label-width="0" class="demo-ruleForm">
                <!--<el-form-item prop="no">-->
                    <!--<el-input :placeholder="paleceholderText + ` #`" v-model="formEdit.no"></el-input>-->
                <!--</el-form-item>-->
                <el-form-item prop="name">
                    <el-input :label="$t('settings_accountThink_taxTypes_name')" v-model="formEdit.name"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input :label="$t('settings_accountThink_taxTypes_code')" v-model="formEdit.code"></el-input>
                </el-form-item>
                <el-form-item v-show="serviceIndex === 0" prop="value">
                    <el-input type="number" label="Rate" v-model="formEdit.value" ></el-input>
                </el-form-item>

                <!-- <el-form-item>
                  <el-radio v-model="formEdit.typeVAT" :label="1">{{$t('settings_accountThink_taxTypes_outputVAT')}}</el-radio>
                  <el-radio v-model="formEdit.typeVAT" :label="2">{{$t('settings_accountThink_taxTypes_inputVAT')}}</el-radio>
                </el-form-item> -->

                <el-form-item prop="description">
                    <el-input :placeholder="$t('settings_accountThink_taxTypes_description')" type="textarea" v-model="formEdit.description"></el-input>
                </el-form-item>
                <el-form-item class="modal__btn">
                  <el-button @click="modalCancel('openModalEdit')">{{$t('general_cancel')}}</el-button>
                    <el-button @click="editItem('formEdit')" type="primary">{{$t('general_submit')}}</el-button>
                </el-form-item>
            </el-form>
        </sweet-modal>
        <!--TAXES EDIT MODAL START-->

        <!--WITHHOLDING TAXES CREATE MODAL START-->
        <sweet-modal blocking :title="`${$t('general_add')} ${btnText}`" ref="openModalWT" class="modal" v-on:close="closeModalWT">
            <el-form :model="formWt" ref="formWt" status-icon :rules="rules" label-width="0" class="demo-ruleForm">
                <!--<el-form-item prop="no">-->
                <!--<el-input :placeholder="paleceholderText + ` #`" v-model="formWt.no"></el-input>-->
                <!--</el-form-item>-->
                <el-form-item prop="name">
                    <el-input :label="$t('settings_accountThink_taxTypes_name')" v-model="formWt.name"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input :label="$t('settings_accountThink_taxTypes_code')" v-model="formWt.code"></el-input>
                </el-form-item>
                <el-form-item prop="value">
                    <el-input type="number" :label="$t('settings_accountThink_taxTypes_taxValue')" v-model="formWt.value"></el-input>
                </el-form-item>
                <el-form-item prop="remark">
                    <el-input  :label="$t('settings_accountThink_taxTypes_remark')" v-model="formWt.remark"></el-input>
                </el-form-item>
                <el-form-item prop="description">
                    <el-input :placeholder="$t('settings_accountThink_taxTypes_description')" type="textarea" v-model="formWt.description"></el-input>
                </el-form-item>
                <el-form-item class="modal__btn">
                  <el-button @click="modalCancel('openModalWT')">{{$t('general_cancel')}}</el-button>
                  <el-button @click="addItem('formWt')" type="primary">{{$t('general_submit')}}</el-button>
                </el-form-item>
            </el-form>
        </sweet-modal>
        <!--WITHHOLDING TAXES CREATE MODAL END-->

        <!--WITHHOLDING EDIT MODAL START-->
        <sweet-modal blocking :title="`${$t('general_edit')} ${btnText}`" ref="openModalEditWT" class="modal" v-on:close="closeModalEditWT">
            <el-form :model="formWtEdit" ref="formWtEdit" status-icon :rules="rulesEdit" label-width="0" class="demo-ruleForm">
                <!--<el-form-item prop="no">-->
                <!--<el-input :placeholder="paleceholderText + ` #`" v-model="formWtEdit.no"></el-input>-->
                <!--</el-form-item>-->
                <el-form-item prop="name">
                    <el-input :label="$t('settings_accountThink_taxTypes_name')" v-model="formWtEdit.name"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input :label="$t('settings_accountThink_taxTypes_code')" v-model="formWtEdit.code"></el-input>
                </el-form-item>
                <el-form-item prop="value">
                    <el-input type="number" :label="$t('settings_accountThink_taxTypes_taxValue')" v-model="formWtEdit.value" ></el-input>
                </el-form-item>
                <el-form-item prop="value">
                    <el-input :label="$t('settings_accountThink_taxTypes_remark')" v-model="formWtEdit.remark" ></el-input>
                </el-form-item>
                <el-form-item prop="description">
                    <el-input :placeholder="$t('settings_accountThink_taxTypes_description')" type="textarea" v-model="formWtEdit.description"></el-input>
                </el-form-item>
                <el-form-item class="modal__btn">
                  <el-button @click="modalCancel('openModalEditWT')">{{$t('general_cancel')}}</el-button>
                  <el-button @click="editItem('formWtEdit')" type="primary">{{$t('general_submit')}}</el-button>
                </el-form-item>
            </el-form>
        </sweet-modal>
        <!--WITHHOLDING EDIT MODAL START-->

    </div>
</template>

<script>
  let moment = require('moment')
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'

  export default {
    name: 'company-taxes',
    components: {
      // AgGridVue,
      SweetModal,

    },
    beforeCreate() {
    },
    beforeMount() {

    },
    computed: {

    },
    mounted(){

    },
    data() {
      return {
        activeTab: 'projectTaxes',
        paleceholderText: this.$i18n.t('settings_accountThink_taxTypes_taxType'),
        btnText: this.$i18n.t('settings_accountThink_taxTypes_taxType'),
        tableData: [],
        selectedRowId: '',
        moment:moment,
        state: 'projectTaxes',
        serviceIndex: null,
        form:{
          name: '',
          code: '',
          value: '',
          // typeVAT: 1,
          description: ''
        },
        formWt:{
          name: '',
          code: '',
          value: '',
          remark:'',
          description: ''
        },
        formEdit:{
          name: '',
          code: '',
          value: '',
          // typeVAT: 1,
          description: ''
        },
        formWtEdit:{
          name: '',
          code: '',
          remark:'',
          value: '',
          description: ''
        },
        rules: {
          name: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          value: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          description: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ]
        },
        rulesEdit: {
          name: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          value: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          description: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ]
        },
      }
    },
    methods: {
      modalCancel(ref) {
        this.$refs[ref].close();
      },
      loadList(state){
        let loader = this.$loading.show();
        if(state){
          this.activeTab = state
        }
        if(state === 'projectTaxes'){
          this.btnText = this.$i18n.t('settings_accountThink_taxTypes_taxType')
          this.paleceholderText = this.$i18n.t('settings_accountThink_taxTypes_taxType')
        }else if(state === 'withholdingTaxes'){
          this.btnText = this.$i18n.t('settings_accountThink_taxTypes_withholdingTax')
          this.paleceholderText = this.$i18n.t('settings_accountThink_taxTypes_withholdingTax')
        }
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${state || this.activeTab}/list?companyId=${this.$route.query.companyId}`)
          .then(response => {
            this.tableData = response.data.list
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      handleClickTabs(tab){
        this.loadList(tab.name)
        console.log(tab.name)
      },
      openModalAdd(tabName){
        switch (tabName){
          case 'projectTaxes':
            this.$refs.openModal.open()
          break;
          case 'withholdingTaxes':
            this.$refs.openModalWT.open()
          break;
        }
      },
      openModalEdit(){

      },
      openModalDelete(){

      },
      addItem(form){
        this.$refs[form].validate((valid) => {
          if (valid) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/${this.activeTab}/create?companyId=${this.$route.query.companyId}`, this.activeTab === 'projectTaxes' ? this.form : this.formWt)
              .then(response => {
                this.activeTab === 'projectTaxes' ? this.$refs.openModal.close() : this.$refs.openModalWT.close()
                this.loadList(this.activeTab)
                this.notification("Success", "Tax Create", "success");
              })
              .catch(error => {
                console.log('An error occurred:', error);
              });
          }else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      closeModal(){
        this.form.name = ''
        this.form.code = ''
        this.form.value = ''
        // this.form.typeVAT = 1
        this.form.description = ''
        this.$refs['form'].resetFields();
      },
      closeModalEdit(){
        this.formEdit.name = ''
        this.formEdit.code = ''
        this.formEdit.value = ''
        // this.formEdit.typeVAT = 1
        this.formEdit.description = ''
        this.$refs['formEdit'].resetFields();
      },
      closeModalWT(){
        this.formWt.name = ''
        this.formWt.code = ''
        this.formWt.value = ''
        this.formWt.remark = ''
        this.formWt.description = ''
        this.$refs['formWt'].resetFields();
      },
      closeModalEditWT(){
        this.formWtEdit.name = ''
        this.formWtEdit.code = ''
        this.formWtEdit.value = ''
        this.formWtEdit.remark = ''
        this.formWtEdit.description = ''
        this.$refs['formWtEdit'].resetFields();
      },
      handleEdit(index, row) {
        console.log(row)
        this.selectedRowId = row.id
        let loader = this.$loading.show();
        let Id = 'projectTaxId'
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${this.activeTab}/item?companyId=${this.$route.query.companyId}&${Id}=${row.id}`)
          .then(response => {
            switch(this.activeTab){
              case'projectTaxes':
                this.formEdit.name = response.data.item.name
                this.formEdit.code = response.data.item.code
                this.formEdit.value = response.data.item.value
                // this.formEdit.typeVAT = response.data.item.typeVAT
                this.formEdit.description = response.data.item.description
                this.serviceIndex = response.data.item.serviceIndex
                this.$refs.openModalEdit.open()
              break;
              case'withholdingTaxes':
                this.formWtEdit.name = response.data.item.name
                this.formWtEdit.code = response.data.item.code
                this.formWtEdit.value = response.data.item.value
                this.formWtEdit.description = response.data.item.description
                this.formWtEdit.remark = response.data.item.remark
                this.$refs.openModalEditWT.open()
                // this.serviceIndex = response.data.item.serviceIndex
              break;
            }
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
      },
      editItem(formEdit){
        this.$refs[formEdit].validate((valid) => {
          if (valid) {
            let loader = this.$loading.show();
            let Id = 'projectTaxId'
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/${this.activeTab}/update?companyId=${this.$route.query.companyId}&${Id}=${this.selectedRowId}`, this.activeTab === 'projectTaxes' ? this.formEdit : this.formWtEdit)
              .then(response => {
                this.activeTab === 'projectTaxes' ? this.$refs.openModalEdit.close() : this.$refs.openModalEditWT.close()
                this.loadList(this.activeTab)
                this.notification("Success", "Tax Edit", "success");
                loader.hide()
              })
              .catch(error => {
                loader.hide()
                console.log('An error occurred:', error);
              });
          }else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      handleDelete(index, row) {
        console.log(row.id)
        // this.$refs.confirmation.open()
        this.selectedRowId = row.id
        console.log(row)

        this.$confirm('This will permanently delete the tax. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'info'
        }).then(() => {
          this.$message({
            type: 'success',
            message: 'Delete completed'
          });

          let Id = ''
          switch(this.activeTab){
            case'projectTaxes':
              Id = 'projectTaxId'
            break;
            case'withholdingTaxes':
              Id = 'withholdingTaxId'
            break
          }
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/${this.activeTab}/delete?companyId=${this.$route.query.companyId}&${Id}=${this.selectedRowId}`)
            .then(response => {
              // this.$refs.confirmation.close()
              this.loadList(this.activeTab)
              this.notification("Success", "Tax Delete", "success");
            })
            .catch(error => {
              console.log('An error occurred:', error);
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });
        });
      },
      showMenu() {
        this.open = true
        console.log('---', this.open);
      },
      hideMenu() {
        this.open = false
        console.log('---', this.open);
      },
      companyName(name) {
        this.companyNameSelect = name
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
    },
    watch:{
      tableData(val){
        val.forEach(i =>{
          i.createDate = moment(i.createDate.toString(), 'X').format('D MMM YY')
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
    .setting-component{
        min-width:810px;
    }
</style>

<style>
.el-tabs--card>.el-tabs__header .el-tabs__nav {
  border-bottom: 1px solid #E4E7ED !important;
  box-sizing: border-box;
}
</style>
